<template>
  <button
    type="button"
    class="flex items-center justify-between rounded-lg bg-primary/5 px-3 py-1 text-sm font-medium text-primary"
  >
    <slot />
  </button>
</template>
